import { useEffect, useRef, useState } from "react";
import { cn } from "~/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

interface TextOverflowProps extends React.HTMLAttributes<HTMLSpanElement> {
  autoTooltip?: boolean;
  delayDuration?: number;
}

const TextOverflow = ({
  autoTooltip,
  delayDuration,
  children,
  className,
  ...props
}: TextOverflowProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => setOverflowing(el.scrollWidth > el.clientWidth);
    check();

    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [children]);

  const tooltipEnabled = autoTooltip && overflowing;

  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger asChild>
        <span ref={ref} className={cn("truncate", className)} {...props}>
          {children}
        </span>
      </TooltipTrigger>
      {tooltipEnabled && <TooltipContent className="max-w-[750px]">{children}</TooltipContent>}
    </Tooltip>
  );
};

export { TextOverflow, type TextOverflowProps };
